import React, {Component, ComponentType} from 'react';
import hoistNonReactStatics from 'hoist-non-react-statics';
import PageContext, {PageContextProps} from 'units/constructor-local/contexts/PageContext';

export default function withPageContext<T extends PageContextProps>(
    WrappedComponent: ComponentType<T>,
) {
    const componentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';

    class WithPageContext extends Component<Omit<T, keyof PageContextProps>> {
        static displayName = `withPageContext(${componentName})`;
        static contextType = PageContext;

        render() {
            return <WrappedComponent {...(this.props as T)} {...this.context} />;
        }
    }

    // Copies non-react specific statics from a child component to a parent component
    hoistNonReactStatics(WithPageContext, WrappedComponent);
    return WithPageContext;
}
